module.exports = __webpack_public_path__ + "static/SpaceMono-Bold-f8009cdcdd3a32a11f4f48294210b9ef.woff";